import Vue from 'vue';


import { Affix } from 'ant-design-vue';
import { Anchor } from 'ant-design-vue';
import { AutoComplete } from 'ant-design-vue';
import { Alert } from 'ant-design-vue';
import { Avatar } from 'ant-design-vue';
import { BackTop } from 'ant-design-vue';
import { Badge } from 'ant-design-vue';
import { Base } from 'ant-design-vue';
import { Breadcrumb } from 'ant-design-vue';
import { Button } from 'ant-design-vue';
import { Calendar } from 'ant-design-vue';
import { Card } from 'ant-design-vue';
import { Collapse } from 'ant-design-vue';
import { Carousel } from 'ant-design-vue';
import { Cascader } from 'ant-design-vue';
import { Checkbox } from 'ant-design-vue';
import { Col } from 'ant-design-vue';
import { DatePicker } from 'ant-design-vue';
import { Divider } from 'ant-design-vue';
import { Dropdown } from 'ant-design-vue';
import { Form } from 'ant-design-vue';
import { FormModel } from 'ant-design-vue';
import { Icon } from 'ant-design-vue';
import { Input } from 'ant-design-vue';
import { InputNumber } from 'ant-design-vue';
import { Layout } from 'ant-design-vue';
import { List } from 'ant-design-vue';
import { LocaleProvider } from 'ant-design-vue';
import { message } from 'ant-design-vue';
import { Menu } from 'ant-design-vue';
import { Mentions } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import { notification } from 'ant-design-vue';
import { Pagination } from 'ant-design-vue';
import { Popconfirm } from 'ant-design-vue';
import { Popover } from 'ant-design-vue';
import { Progress } from 'ant-design-vue';
import { Radio } from 'ant-design-vue';
import { Rate } from 'ant-design-vue';
import { Row } from 'ant-design-vue';
import { Select } from 'ant-design-vue';
import { Slider } from 'ant-design-vue';
import { Spin } from 'ant-design-vue';
import { Statistic } from 'ant-design-vue';
import { Steps } from 'ant-design-vue';
import { Switch } from 'ant-design-vue';
import { Table } from 'ant-design-vue';
import { Transfer } from 'ant-design-vue';
import { Tree } from 'ant-design-vue';
import { TreeSelect } from 'ant-design-vue';
import { Tabs } from 'ant-design-vue';
import { Tag } from 'ant-design-vue';
import { TimePicker } from 'ant-design-vue';
import { Timeline } from 'ant-design-vue';
import { Tooltip } from 'ant-design-vue';
import { Upload } from 'ant-design-vue';
import { version } from 'ant-design-vue';
import { Drawer } from 'ant-design-vue';
import { Skeleton } from 'ant-design-vue';
import { Comment } from 'ant-design-vue';
import { ConfigProvider } from 'ant-design-vue';
import { Empty } from 'ant-design-vue';
import { Result } from 'ant-design-vue';
import { Descriptions } from 'ant-design-vue';
import { PageHeader } from 'ant-design-vue';

Vue.use( Button)
Vue.use( Affix)
Vue.use( Anchor)
Vue.use( Alert)
Vue.use( AutoComplete)
Vue.use( Avatar)
Vue.use( BackTop)
Vue.use( Badge)
Vue.use( Base)
Vue.use( Breadcrumb)
Vue.use( Calendar)
Vue.use( Card)
Vue.use( Collapse)
Vue.use( Carousel)
Vue.use( Cascader)
Vue.use( Checkbox)
Vue.use( Col)
Vue.use( DatePicker)
Vue.use(Divider)
Vue.use(Dropdown)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Icon)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Layout)
Vue.use(List)
Vue.use(LocaleProvider)
Vue.use(message)
Vue.use(Menu)
Vue.use(Mentions)
Vue.use(Modal)
Vue.use(notification)
Vue.use(Pagination)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Rate)
Vue.use(Row)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Spin)
Vue.use(Statistic)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(Table)
Vue.use(Transfer)
Vue.use(Tree)
Vue.use( TreeSelect)
Vue.use( Tabs)
Vue.use( Tag)
Vue.use( TimePicker)
Vue.use( Timeline)
Vue.use( Tooltip)
Vue.use( Upload)
Vue.use( version)
Vue.use( Drawer)
Vue.use( Skeleton)
Vue.use( Comment)
Vue.use( ConfigProvider)
Vue.use( Empty)
Vue.use( Result)
Vue.use( Descriptions)
Vue.use( PageHeader)

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;
